<form
  class="fs-7 d-flex flex-wrap gap-2"
  [formGroup]="filtersForm"
>
  <base-filter-dropdown
    [items]="baseOfferStatusOption"
    filterName="state"
    optionClass="class"
    formControlName="status"
    [multiple]="false"
  ></base-filter-dropdown>
  <base-filter-dropdown
    [items]="baseCustomerWCApprovalOptions"
    filterName="workCouncil.label"
    optionClass="class"
    formControlName="workCouncilStatus"
    [multiple]="false"
  ></base-filter-dropdown>
  <base-filter-dropdown
    [items]="qualifications"
    filterName="qualifications.plural"
    formControlName="mainQualifications"
    [searchable]="true"
  ></base-filter-dropdown>
  <base-filter-dropdown
    [items]="branches"
    [searchable]="true"
    formControlName="pspBranches"
    filterName="provider"
  ></base-filter-dropdown>
  <base-filter-dropdown
    [items]="[5, 4, 3, 2, 1]"
    filterName="review"
    bindOptionLabel="value"
    formControlName="rating"
    class="rating-filter"
    [searchable]="false"
    [isRatingLayout]="true"
    [multiple]="false"
  ></base-filter-dropdown>
  <base-filter-dropdown
    [items]="experienceOptions"
    [searchable]="false"
    bindOptionLabel="label"
    formControlName="experience"
    filterName="tooltip.experienceInCompany"
    [multiple]="false"
  ></base-filter-dropdown>
</form>
<hr *ngIf="activeFilters.length" />
<div class="fs-7 d-flex align-items-center flex-wrap gap-2">
  <div
    *ngFor="let filter of activeFilters"
    class="px-2_5 rounded-pill bg-secondary py-2 active-filter fw-semibold"
  >
    <span
      class="pe-1 fw-normal"
      [ngClass]="{ 'fw-bold': filter.filter === inquiryOffersFiltersType.experience }"
    >
      {{
        filter.filter === inquiryOffersFiltersType.search
          ? ('search.nominative' | translate) + ':'
          : filter.filter === inquiryOffersFiltersType.experience
          ? (filtersForm.getRawValue()?.experience?.label | translate)
          : (labels[filter.filter] | translate) + ':'
      }}
    </span>
    <ng-container
      *ngIf="filter.filter !== inquiryOffersFiltersType.rating && filter.filter !== inquiryOffersFiltersType.experience"
    >
      <span>
        {{
          (filter?.name | translate) ||
            (filter.value.label | translate) ||
            (filter.value.name | translate) ||
            (filter.value | baseFormatDate)
        }}
      </span>
    </ng-container>
    <ng-container *ngIf="filter.filter === inquiryOffersFiltersType.rating">
      <base-rating
        [currentRate]="filter.value"
        [hideCount]="true"
        class="my-0 mx-auto"
      ></base-rating>
    </ng-container>
    <i
      class="fa-solid fa-xmark ms-2 pointer"
      (click)="removeFilter(filter)"
    ></i>
  </div>
  <div
    class="pointer"
    (click)="clearFilters()"
    *ngIf="activeFilters.length"
  >
    {{ 'filter.reset' | translate }}
  </div>
</div>
